export default () => {
  return `<ul class="context-menu">
  <li class="context-menu__item">
  <a href="#" class="context-menu__link">
      View Task
    </a>
  </li>
  <li class="context-menu__item">
    <a href="#" class="context-menu__link">
      Edit Task
    </a>
  </li>
  <li class="context-menu__item">
    <a href="#" class="context-menu__link">
      Delete Task
    </a>
  </li>
</ul>`;
};
